/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { MatchAuditResponse } from '../models/MatchAuditResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class MatchAuditService {
    /**
     * Get Match Audit Log
     * @param matchId
     * @returns any Successful Response
     * @throws ApiError
     */
    public static getMatchAuditLogMatchAuditMatchMatchIdGet(
        matchId: number,
    ): CancelablePromise<(MatchAuditResponse | null)> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/match_audit/match/{match_id}',
            path: {
                'match_id': matchId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
